import { useState, useRef } from 'react';
import { debounce } from 'lodash'

import { 
    getPharmacies,
    getPharmacyDetails
} from '../api/PharmacyAPI'

export const usePharmacies = (pharmacyId=null) => {
    const [pharmacySearchResults, setPharmacySearchResults] = useState([])
    const [pharmaciesLoading, setPharmaciesLoading] = useState(false)
    const [selectedPharmacy, selectPharmacy] = useState(null)

    const abortController = useRef(null)

    const fetchPharmacy = async pharmacyId => {
        if (!pharmacyId) return

        try {
            const { data: { pharmacy } } = await getPharmacyDetails(pharmacyId)
            return pharmacy
        } catch (e) {
            console.log(e)
            throw new Error('Error fetching pharmacy')
        }
    }

    const searchPharmacies = debounce(async (pharmacyName) => {
        selectPharmacy(null)

        if (pharmacyName?.length < 3) return

        setPharmaciesLoading(true)
        setPharmacySearchResults([])

        abortController.current?.abort()
        abortController.current = new AbortController()

        try {
            getPharmacies(pharmacyName)
                .then(({ data: { pharmacies }, config: { body } }) => {
                    if (!abortController.current?.signal || !body?.signal.aborted) {
                         setPharmacySearchResults(pharmacies)
                         setPharmaciesLoading(false)
                    }
                })
        } catch (e) {
            console.log(e)
        } finally {
            setPharmaciesLoading(false)
        }
    }, 500)

    const selectPharmacyByNcpdpId = (ncpdpId) => {
        if (!ncpdpId) return

        const pharmacyMatch = pharmacySearchResults.find(pharmacy => pharmacy.ncpdpId === ncpdpId)
        if (!pharmacyMatch) return

        selectPharmacy(pharmacyMatch)
    }

    const selectPharmacyById = (pharmacyId) => {
        if (!pharmacyId) return

        const pharmacyMatch = pharmacySearchResults.find(pharmacy => pharmacy.pharmacyId === pharmacyId)
        if (!pharmacyMatch) return

        selectPharmacy(pharmacyMatch)
    } 

    return { 
        pharmacySearchResults,
        pharmaciesLoading,
        fetchPharmacy,
        selectPharmacyById,
        selectPharmacyByNcpdpId,
        selectPharmacy,
        selectedPharmacy,
        searchPharmacies
    }
}